import styled from 'styled-components';

import { DefaultThemeSettings } from './DefaultThemes';

export const AutoMode = styled(DefaultThemeSettings)`
  header.ant-layout-header,
  .search-container-on-mobile {
    background: ${(props) =>
      props.tenantTheme['general-theme'].themeMasterColor};
  }

  .search-input {
    background: ${(props) =>
      props.tenantTheme['general-theme'].themeMasterColor};
    filter: brightness(1.15);
  }

  header.ant-layout-header {
    .icon.sidebar {
      color: #ffffff;
    }

    .content-container {
      .site-title h1,
      .anticon-search.icon,
      .course_options,
      ul li,
      ul li i {
        color: #ffffff;
      }
    }
  }
`;
